// Small helper to turn an axios/API error into a user-facing message without
// leaking raw backend internals. Prefer a short, friendly fallback over
// surfacing SQL/API text.
export const getErrorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  const data = err?.response?.data;
  const candidate = (typeof data?.error === "string" && data.error.trim())
    ? data.error
    : (typeof data?.message === "string" && data.message.trim())
      ? data.message
      : null;
  if (candidate) return candidate;
  if (typeof err?.message === "string" && err.message.trim() && !/network|timeout/i.test(err.message)) {
    // Only surface client-side messages (e.g. "Request failed"), never
    // low-level transport details.
    return err.message;
  }
  return fallback;
};

export default getErrorMessage;
